import getColor from "@insite/mobius/utilities/getColor";
import { customLinkCallToActionStyles } from "@solveindustrial/Utilities/styleguide";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { categoryCardWidgetStyles as styles } from "@solveindustrial/Widgets/VerndaleBox/CategoryCardWidget";
import { css } from "styled-components";

styles.wrapper = {
    css: css`
        border: 1px solid ${getColor(colorStrings.commonGlobalGray03)};
        height: 100%;
        border-radius: 4px;

        &.cat-card__wrapper--with-hover {
            &:hover {
                box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.15);
                cursor: pointer;
            }
        }

        & > [class*="LazyImageStyle"] {
            justify-content: start;
        }

        img {
            min-height: 250px;
            object-fit: cover;
            aspect-ratio: 1;
        }
    `,
};

styles.thumbnail = {
    css: css`
        aspect-ratio: 1;
        text-align: center;
        padding: 10px;
    `,
};

styles.textWrapper = {
    css: css`
        padding: 10px;
    `,
};

styles.name = {
    variant: "h4",
    forwardAs: "h3",
    color: colorStrings.primaryMain,
    weight: 700,
    css: css`
        margin-bottom: 8px;
    `,
};

styles.title = {
    variant: "body",
    color: colorStrings.commonGlobalGray02,
    css: css`
        margin-bottom: 8px;
    `,
};

styles.link = {
    ...styles.link,
    css: css`
        ${styles.link?.css}
        ${customLinkCallToActionStyles}
    `,
};

styles.linkCard = {
    ...styles.linkCard,
    css: css`
        display: block;
    `,
};
